
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M3.792 17.01v-4.376a1.042 1.042 0 00-2.083 0v4.583c0 1.036.84 1.875 1.874 1.875h5a1.042 1.042 0 000-2.083H3.792zm13.75 0H12.75a1.042 1.042 0 000 2.082h5c1.036 0 1.875-.839 1.875-1.875v-4.583a1.042 1.042 0 00-2.083 0v4.375zM3.792 3.26h4.791a1.042 1.042 0 000-2.084h-5c-1.035 0-1.875.84-1.875 1.875v4.583a1.042 1.042 0 002.084 0V3.26zm13.75 0v4.374a1.042 1.042 0 002.083 0V3.051c0-1.036-.84-1.875-1.875-1.875h-5a1.042 1.042 0 000 2.083h4.792z"}})])
          )
        }
      }
    